module.exports = __webpack_public_path__ + "img/siegeworkshop64_ua.af943c8c.webp";